export const placeholderClasses = (): string => "e-placeholder__root";
